







import { defineComponent, PropType, computed } from "@vue/composition-api";
import { LikesStatistic } from "@scrile/api-provider/dist/api/LikeProvider";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ContentFeedLikes",
  components: { BaseIcon },
  props: {
    likes: { type: Object as PropType<LikesStatistic | null> },
    noCount: { type: Boolean },
  },
  setup(props) {
    const isLiked = computed(() => props.likes && props.likes.liked);
    const icon = computed(() => (isLiked.value ? "sci-heart" : "sci-heart-outline"));

    return {
      isLiked,
      icon,
    };
  },
});
